import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { ProjectsList } from '@/components/projects/projects-list'
import type { ProjectsSearch } from '@/components/projects/projects-search-schema'

export const Route = createFileRoute('/_app/clients/$clientId/projets')({
  component: ClientProjectsPage,
})

function ClientProjectsPage() {
  const client = useShellClient()
  const [filters, setFilters] = useState<ProjectsSearch>({})
  return (
    <Frame>
      <ProjectsList
        search={filters}
        fixedClient={{ id: client.id, name: client.name }}
        onSearchChange={(next) => {
          setFilters((current) => ({ ...current, ...next }))
        }}
      />
    </Frame>
  )
}
